/**
 * Merges two objects, with defined values from update overriding target.
 * Undefined values in update are ignored (preserves target values).
 * 
 * Used when merging position data from different sources (query vs stream)
 * to preserve fields that might be missing in one source but present in the other.
 */
export function mergeDefined(target, update) {
  if (!update) return target;
  const filteredUpdate = Object.fromEntries(
    Object.entries(update).filter(([, value]) => value !== undefined)
  );
  return { ...(target || {}), ...filteredUpdate };
}

